import LoadingBox from './src/LoadingBox'
import _LoadingBoxMobile from './src/LoadingBoxMobile'

export const LoadingBoxMobile = _LoadingBoxMobile
export default LoadingBox
